import React from 'react'
import './whatAUREO.css'

const WhatAUREO = () => (
  <section className="aureo-statement">
    <p className="aureo-statement__overline fade-up">What We Do</p>
    <h2 className="aureo-statement__heading fade-up delay-1">
      We Don't Build Websites.<br />We Build Revenue Machines.
    </h2>
    <p className="aureo-statement__body fade-up delay-2">
      Most agencies optimize for aesthetics. We optimize for outcomes. Every decision — from store
      architecture to keyword clusters to the angle of a product photo — is made with one question
      in mind: does this convert? Small team, obsessive focus, measurable results.
    </p>
    <div className="aureo-statement__rule fade-up delay-3" aria-hidden="true" />
  </section>
)

export default WhatAUREO
